import dynamic from 'next/dynamic';
const ToolTip = dynamic(() => import('./tooltip.js'), { ssr: false });
export default ToolTip;
